import * as React from "react";
import { useGetConfigAppQuery } from "../../../utils/api/config/config.api";
import { createMarkup } from "../../../utils/Utils";
import { TextSkeleton } from "../../admin/Parametres/Steps/CguAdmin";
import FooterPage from "../../auth/FooterPage";
import FrontFooter from "../FrontFooter/FrontFooter";
import FrontHeader from "../FrontHeader/FrontHeader";

const CguPage = () => {
  const { data, isLoading } = useGetConfigAppQuery();
  
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content bg-white py-5">
        <div className="container-easy-market">
          <div className="container">
            <div className="container-banner-policy">
              <h2 className="title-banner-policy">Politique générale de vente</h2>
            </div>
            <div className="container-text-policy pb-5">
              {!!isLoading && <TextSkeleton />}
              {!isLoading && (
                data?.cgu ? (
                  <div
                    className="text-policy"
                    dangerouslySetInnerHTML={createMarkup(data?.cgu)}
                  />
                ) : (
                  <div className="custom-politique-page-content pt-5">
                    <div className="content-all-politique pt-4 pb-3">
                      <div className="content-politique-item">
                        <h3 className="custom-sm-title pb-4">
                          1. Commandes et Paiements
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              1.1. Passer une Commande
                            </h3>
                            <div className="custom-sm-value">
                              En passant une commande sur notre site, vous acceptez d'acheter les produits ou services sélectionnés aux prix et conditions indiqués.
                            </div>
                          </div>
                          <div className="content-politique-item pt-2">
                            <h3 className="custom-sm-title pb-4">
                              1.2. Paiements
                            </h3>
                            <div className="custom-sm-value">
                              Les paiements sont traités de manière sécurisée via des méthodes de paiement en ligne sécurisées. Les informations de paiement sont cryptées et protégées.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          2. Livraison et Frais de Port
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              2.1.
                            </h3>
                            <div className="custom-sm-value">
                              Nous disposons d'un système de logistique optimisé entre la Chine et le Sénégal, garantissant une livraison rapide et fiable.
                            </div>
                            <div className="custom-sm-value pt-3">
                              <ul className="custom-instruction-list">
                                <li className="listitem">
                                  <strong>Livraison express :</strong> 1 à 3 jours
                                </li>
                                <li className="listitem">
                                  <strong>Livraison standard :</strong> 6 à 10 jours
                                </li>
                              </ul>
                            </div>
                            <div className="custom-sm-value pt-3">
                              Chaque colis est suivi en temps réel pour garantir une réception sans souci.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          3. Politique de Retour et de Remboursement
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              3.1.
                            </h3>
                            <div className="custom-sm-value">
                              Les produits peuvent être retournés dans un délai de <strong>3 jours</strong> après réception, mais uniquement en cas de défaut du produit ou d'erreur dans la commande livrée.
                            </div>
                          </div>
                          <div className="content-politique-item pt-2">
                            <h3 className="custom-sm-title pb-4">
                              3.2.
                            </h3>
                            <div className="custom-sm-value">
                              Les remboursements sont traités dans un délai de <strong>5 à 10 jours ouvrables</strong> après la validation du produit retourné.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          4. Responsabilité
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              4.1. Limitation de Responsabilité
                            </h3>
                            <div className="custom-sm-value">
                              Nous déclinons toute responsabilité pour tout dommage direct, indirect, spécial, consécutif ou punitif résultant de l'utilisation de nos produits ou services.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          5. Modifications de la Politique
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              5.1. Modifications
                            </h3>
                            <div className="custom-sm-value">
                              Nous nous réservons le droit de modifier cette Politique à tout moment. Les modifications prennent effet dès leur publication sur le site.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="content-politique-item pt-5">
                        <h3 className="custom-sm-title pb-4">
                          6. Contact
                        </h3>
                        <div className="custom-sm-value">
                          <div className="content-politique-item">
                            <h3 className="custom-sm-title pb-4">
                              6.1. Contact
                            </h3>
                            <div className="custom-sm-value">
                              Pour toute question concernant cette Politique générale de vente, vous pouvez nous contacter via les coordonnées fournies sur notre site.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
          <FooterPage />
        </div>
      </div>
      <FrontFooter />
    </div>
  );
};

export default CguPage;